import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamMentor, DropoutUpsertValues } from '@interfaces';
import { DropoutDialog } from 'ui/widget/dialog/dropout';
import { DropoutDialogData } from 'ui/widget/dialog/dropout/dropout.dialog';
import { PersonDialog } from '../../../../person-dialog';
import { VolunteerDialog } from '../../../volunteer-dialog/volunteer.dialog';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';

export function getActions(dialogService: DialogService, dialogDataService: AccTeamDialogDataService) {

	const actions: GridAction<AccTeamMentor>[] = [
		{
			iconClass: 'fa-regular fa-times',
			label: 'Edit Drop Out Mentor',
			isEnabled: rows => !!rows.length && (dialogDataService.canEdit() || dialogDataService.canEditMentors()),
			execute: async rows => {
				const accMentorId = rows[0]!.accMentorId; // checked for length above, safe to assert non-null
				const dropoutId = rows[0]!.dropout?.dropoutId;

				const action = await dialogService.showCustom<DropoutDialog, DropoutDialogData>(DropoutDialog, { data: { dropoutTargetType: 'Mentor', dropoutId } }, 650, 500);

				const result = action?.callbackResult as DropoutUpsertValues | undefined;
				if (result) {
					if (dropoutId) {
						await dialogDataService.updateMentorDropout(accMentorId, dropoutId, result);
					} else {
						await dialogDataService.addMentorDropout(accMentorId, result);
					}
				}
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-tie',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
			}
		},
	];

	return actions;
}